import type { IRemoteNotification } from "@suprsend/web-sdk";


function readIntentField(workflowDataBlob: unknown): string | undefined {
  if (workflowDataBlob == null) {
    return undefined;
  }
  if (typeof workflowDataBlob === "string") {
    const trimmed = workflowDataBlob.trim();
    if (!trimmed) {
      return undefined;
    }
    try {
      const parsed: unknown = JSON.parse(trimmed);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        const intent = (parsed as { intent?: unknown }).intent;
        if (intent == null) {
          return undefined;
        }
        return String(intent).trim() || undefined;
      }
    } catch {
      return undefined;
    }
    return undefined;
  }
  if (typeof workflowDataBlob === "object" && workflowDataBlob !== null) {
    if (!("intent" in workflowDataBlob)) {
      return undefined;
    }
    const intent = (workflowDataBlob as { intent?: unknown }).intent;
    if (intent == null) {
      return undefined;
    }
    return String(intent).trim() || undefined;
  }
  return undefined;
}

/**
 * Returns the `intent` string for inbox notification sound routing, or `undefined` if missing.
 */
export function getIntentForInboxSound(
  notification: IRemoteNotification | undefined,
): string | undefined {
  const messageBody = notification?.message;
  if (messageBody == null || typeof messageBody !== "object") {
    return undefined;
  }
  const fields = messageBody as unknown as Record<string, unknown>;
  return readIntentField(fields.extra_data) ?? readIntentField(fields.data);
}

/**
 * `notification_intent_sounds_mapping` from mobile config: JSON string or object, intent key → sound URL.
 */
export function intentKeyToSoundUrlMap(
  configValue: unknown,
): Record<string, string> {
  if (configValue == null || configValue === "") {
    return {};
  }
  if (
    typeof configValue === "object" &&
    !Array.isArray(configValue) &&
    configValue !== null
  ) {
    return configValue as Record<string, string>;
  }
  if (typeof configValue === "string") {
    try {
      const parsed: unknown = JSON.parse(configValue);
      if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
        return parsed as Record<string, string>;
      }
    } catch {
      return {};
    }
  }
  return {};
}
